import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { AccountancyEmailStatusesNotificatorBase } from '@skylab-shared/business';
import { EventNotificationsService } from '../event-notifications.service';

@Injectable({ providedIn: 'root'})
@Wrapper(AccountancyEmailStatusesNotificatorBase)
export class AccountancyEmailStatusesNotificator {
    public constructor(
        eventNortifications: EventNotificationsService,
        http: Http
    ) { }
}
